module.exports = __webpack_public_path__ + "static/media/Rainbow_Pride.df7159d0.gif";